<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item
        v-if="request_prefix === 'bigScreen'"
        title="位置尺寸"
        name="0"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '0')"
      >
        <widthAndSizeAndZindex
          :options="options"
          :ids="ids"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '0')"
        />
      </el-collapse-item>
      <chart-common-options-setting-1 :options="options" :ids="ids"></chart-common-options-setting-1>
      <el-collapse-item title="特效" name="1" @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')">
        <series-setting
          :options="options"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')"
        />
      </el-collapse-item>
      <el-collapse-item
        title="全局配置"
        name="2"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
      >
        <global-setting
          :options="options"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
        />
      </el-collapse-item>
      <el-collapse-item
        title="区域设置"
        name="3"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
      >
        <area-setting
          :options="options"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
        />
      </el-collapse-item>
      <el-collapse-item
        title="区域标签"
        name="4"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
      >
        <area-label
          :options="options"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
        />
      </el-collapse-item>
      <!-- 边距设置 -->
      <el-collapse-item
          title="边距"
          name="6"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
      >
        <div
            class="setting-item setting-item-grid"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
        >
          <el-checkbox class="mb12" v-model="isSelfPadding">自定义边距</el-checkbox>
          <cx-padding
              v-if="isSelfPadding"
              :paddingTypeFlag.sync="paddingTypeFlag"
              :padding.sync="padding"
              :paddingTop.sync="paddingTop"
              :paddingRight.sync="paddingRight"
              :paddingBottom.sync="paddingBottom"
              :paddingLeft.sync="paddingLeft"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="$store.state.states.showPluginSetting"
        title="插件"
        name="5"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
      >
        <pluginSetting
          :options="options"
          v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
        />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex"
import seriesSetting from "./mapSettings/seriesSetting"
import globalSetting from "./mapSettings/globalSetting"
import areaSetting from "./mapSettings/areaSetting"
import areaLabel from "./mapSettings/areaLabel"
import pluginSetting from "./mapSettings/pluginSetting"
import ChartCommonOptionsSetting1 from "toolbarComponents/bigScreen/common/chart-common-options-setting-1"
export default {
  components: {
    globalSetting,
    areaSetting,
    areaLabel,
    seriesSetting,
    pluginSetting,
    widthAndSizeAndZindex,
    ChartCommonOptionsSetting1,
  },
  props: { options: Object },
  data() {
    return {
      activeNames: ["0", "1", "2"],
      allCollapseNames: ["3", "4", "5"],
      collapseActiveNames: ["0", "1", "2"]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    chartOption() {
      return this.options.chartOption
    },
    isSelfPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "chartOption.isSelfPadding", "chartOption.isSelfPadding", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.isSelfPadding", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.chartOption.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "chartOption.paddingTypeFlag", "chartOption.paddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "chartOption.padding", "chartOption.padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "chartOption.paddingTop", "chartOption.paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "chartOption.paddingRight", "chartOption.paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "chartOption.paddingLeft", "chartOption.paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "chartOption.paddingBottom", "chartOption.paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.paddingBottom", false)
      }
    },
  },
  mounted() {
    this.$collapseControl({
      activeNames: this.activeNames,
      collapseActiveNames: this.collapseActiveNames,
      allCollapseNames: this.allCollapseNames
    })
  }
}
</script>

<style>
  .clear-url-btn{
    width: 100%;
  }
  .el-button.clear-url-btn:hover,
  .el-button.clear-url-btn:focus {
    color: var(--themeColor);
    border: 1px solid var(--themeColor);
    background-color: transparent;
  }
</style>
